import { useEffect } from "react";
import { useApolloClient } from "@apollo/client";
import { LoadingSplash } from "@songtradr-one/components-frontend";
import { getSsoClient } from "../../helpers/get-sso-client";
import { PROBE_QUERY, isAllowedRedirect } from "./AuthRedirect.Parts";

// Bridge route used by Lambda@Edge-protected static sites (e.g. Storybook)
// that have no client-side code of their own. Edge redirects the viewer to
// `/auth-redirect?to=<originalUrl>`; this component drives the SSO flow on
// the app's domain so the `sso` cookie is set with `Domain=<root>` (broad
// enough to propagate to the original site's subdomain), then bounces back.
export const AuthRedirect = () => {
  const client = useApolloClient();

  useEffect(() => {
    const url = new URLSearchParams(window.location.search);
    const token = url.get("token");
    const to = url.get("to");

    if (!to || !isAllowedRedirect(to)) return;

    if (token) {
      void client
        .query({ query: PROBE_QUERY, fetchPolicy: "no-cache" })
        .finally(() => window.location.assign(to));
    } else void getSsoClient().redirects.signIn(window.location.href);
  }, [client]);

  return <LoadingSplash />;
};
